<template>
  <div class="extend_time__form">
    <!-- สำนักงานปลัดกระทรวงอุดมศึกษาฯ (สป.อว.) -->
    <div class="custom_card mt-4">
      <v-layout justify-space-between pa-3>
        <v-flex shrink class="pr-4">
          <v-img
            :src="
              require('../../../../assets/images/extension-time/logo-rsp.png')
            "
            width="100"
            height="100"
          ></v-img>
        </v-flex>
        <v-flex xs8>
          <h1>สำนักงานปลัดกระทรวงอุดมศึกษาฯ (สป.อว.)</h1>
          <div class="font-12 font-w-400 mt-2">
            <Iconify
              class="mr-3"
              icon="ic:round-access-time"
              size="15px"
            ></Iconify>
            <span>
              วันที่เปิดรับโครงการ 31 พฤศจิกายน 2565 เวลา 00:00 น. - 30 ธันวาคม
              2565 เวลา 12:00 น.
            </span>
          </div>
          <div class="font-12 font-w-400 mt-2">
            <Iconify
              class="mr-3"
              icon="ic:round-access-time"
              size="15px"
            ></Iconify>
            <span>
              วันที่พิจารณาโครงการ 3 มกราคม 2566 เวลา 08:00 น. - 5 มกราคม 2566
              เวลา 12:00 น.
            </span>
          </div>
          <div class="font-12 font-w-400 pl-6 mt-2">
            โครงการส่งเสริมกิจการอุทยานวิทยาศาสตร์
            (นิคมธุรกิจวิทยาศาสตร์ภูมิภาค)
          </div>
        </v-flex>
        <v-spacer />
        <v-flex shrink>
          <div
            class="custom_card d-flex flex-column align-center justify-center"
            style="
              background-color: #f15a29;
              color: #fff;
              width: 100px;
              height: 100px;
              padding: 5px;
            "
          >
            <div class="font-20 font-w-600">ปี งปม.</div>
            <div class="font-32 font-w-600">2566</div>
            <div></div>
          </div>
        </v-flex>
      </v-layout>
    </div>

    <div class="font-20 font-w-600 mb-2 mt-5">แผนงาน</div>
    <div class="font-16 font-w-500 mb-6">
      {{ form.plan_name }}
    </div>

    <div class="font-20 font-w-600 mb-4">รายการโครงการย่อยที่ขอขยายเวลา</div>

    <table class="custom_table mb-4">
      <thead>
        <tr>
          <th width="5%">ลำดับ</th>
          <th width="45%">ชื่อโครงการ</th>
          <th width="10%">มหาวิทยาลัย</th>
          <th width="10%">ผู้นำเข้าข้อมูล</th>
          <th width="10%">ครั้งที่</th>
          <th width="10%">ระยะที่ขอขยาย</th>
          <th width="10%">ขยายถึง</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, i) in form.projects" :key="i">
          <td>{{ i + 1 }}</td>
          <td>{{ item.project_name_th }}</td>
          <td>{{ item.university }}</td>
          <td>{{ item.user_name }}</td>
          <td>{{ item.project_no }}</td>
          <td>{{ item.duration }}</td>
          <td>{{ item.end_date }}</td>
        </tr>
      </tbody>
    </table>

    <div class="font-20 font-w-600 mb-4">รายการโครงการย่อยที่ขอขยายเวลา</div>

    <div class="custom_card pa-6">
      <v-layout class="mb-3">
        <v-flex xs1>
          <div class="font-14 font-w-600">
            เหตุผล <span style="color: #f15a29">*</span>
          </div>
        </v-flex>
        <v-flex xs11>
          <div class="font-14">
            {{ form.reason ? form.reason : "- ไม่มีข้อมูล -" }}
          </div>
        </v-flex>
      </v-layout>

      <div class="font-14 font-w-700 mb-2">เอกสารเเนบ</div>

      <v-layout
        align-center
        class="mt-3"
        v-for="(file, f) in form.files"
        :key="f"
      >
        <v-flex shrink>
          <v-btn
            depressed
            dark
            rounded
            width="100"
            color="#F15A29"
            @click="downloadFile(file)"
          >
            <Iconify
              style="color: #fff"
              icon="system-uicons:download"
            ></Iconify>
            <span class="font-12 font-w-700">ดาวน์โหลด</span>
          </v-btn>
        </v-flex>
        <v-flex shrink ml-3>
          {{ file.doc_file }}
        </v-flex>
      </v-layout>
    </div>

    <v-btn
      class="mt-6"
      rounded
      depressed
      color="#D9D9D9"
      @click="$router.push('/rsp/extend-time')"
    >
      <span style="color: #464647">ย้อนกลับ</span>
    </v-btn>
  </div>
</template>

<script>
import DatePicker from "../../../../components/input/DatePicker.vue";
export default {
  components: { DatePicker },
  data() {
    return {
      valid: true,
      plans: [
        {
          plan_name_th:
            "แผนงานพัฒนาขีดความสามารถทางเทคโนโลยีและวิจัยของภาคเอกชนในพื้นที่ (IRTC)",
          plan_code: "1",
        },
        {
          plan_name_th: "แผนงานวิจัยร่วมกับภาคเอกชน  Collaborative Research",
          plan_code: "2",
        },
        {
          plan_name_th:
            "แผนงานบ่มเพาะธุรกิจวิทยาศาสตร์ เทคโนโลยีและนวัตกรรม STI Business Incubation",
          plan_code: "3",
        },
        {
          plan_name_th: "แผนงานพัฒนาบริการอุทยานวิทยาศาสตร์ Service Platform",
          plan_code: "4",
        },
      ],

      form: {
        plan_master_id: null,
        plan_name: "",
        plan_code: "",
        projects: [],
        reason: null,
        files: [],
      },
      rulesFile: [
        (value) =>
          !value ||
          value.size < 10000000 ||
          "File size should be less than 10 MB!",
        (value) => !!value || "กรุณาแนบเอกสาร",
      ],
    };
  },
  created() {
    console.log(this.$route.params.id);

    if (this.$route.params.id) {
      this.form = {
        plan_master_id: null,
        plan_name:
          "แผนงานพัฒนาขีดความสามารถทางเทคโนโลยีและวิจัยของภาคเอกชนในพื้นที่ (IRTC)",
        plan_code: "1",
        projects: [
          {
            id: 1,
            project_name_th: "โครงการพัฒนาสารกำจัดมด",
            university: "มหาวิทยาลัยสุรนารี",
            user_name: "user",
            project_no: "ครั้งที่ 1",
            duration: "6 เดือน",
            end_date: "10 ม.ค 2566",
          },
          {
            id: 2,
            project_name_th: "โครงการพัฒนาสารกำจัดมด",
            university: "มหาวิทยาลัยสุรนารี",
            user_name: "user",
            project_no: "ครั้งที่ 1",
            duration: "6 เดือน",
            end_date: "10 ม.ค 2566",
          },
        ],
        reason:
          "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Esse voluptatem recusandae libero dicta labore delectus voluptas, eos eum eaque illo, molestias in iste ducimus fuga, consequatur nesciunt ipsam fugiat dignissimos?",
        files: [
          {
            doc_file: "file.pdf",
          },
          {
            doc_file: "file.pdf",
          },
        ],
      };
    }
  },
  methods: {
    downloadFile(file) {
      console.log("download", file);
    },
  },
};
</script>

<style lang="scss">
.extend_time__form {
  .custom_card {
    background: #ffffff;
    box-shadow: 1px 1px 30px rgba(0, 0, 0, 0.1);
    border-radius: 20px;
    padding: 15px 25px;
  }

  .custom_table {
    width: 100%;
    border-collapse: collapse;
    border-spacing: 0;
    margin-bottom: 20px;
    thead {
      // background-color: #f2f2f2;
      color: #b1b1b1;
      th {
        padding: 12px;
        border-bottom: 1px solid #ddd;
        text-align: left;
      }
    }
    tbody {
      tr {
        &:nth-child(even) {
          // background-color: #f2f2f2;
        }
        td {
          padding: 12px;
        }
      }
    }
  }

  .custom_file_input {
    .v-text-field--full-width .v-input__prepend-outer,
    .v-text-field--full-width .v-input__prepend-inner,
    .v-text-field--full-width .v-input__append-inner,
    .v-text-field--full-width .v-input__append-outer,
    .v-text-field--enclosed .v-input__prepend-outer,
    .v-text-field--enclosed .v-input__prepend-inner,
    .v-text-field--enclosed .v-input__append-inner,
    .v-text-field--enclosed .v-input__append-outer {
      margin-top: 4px !important;
    }
  }

  .v-input__slot,
  .v-text-field.v-text-field--solo .v-input__control {
    min-height: inherit !important;
  }
  .v-input--is-readonly:not(.picker-field) .v-input__slot {
    background-color: #ffffff !important;
  }

  .v-input__icon--clear {
    background: #d9d9d9;
    color: #fff !important;
  }

  .btn-save {
    background: linear-gradient(21.01deg, #f15a29 6.18%, #fbb040 84.83%);
    box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.25);
    border-radius: 30px;
    padding: 0px 10px;
  }
  input {
    font-size: 16px !important;
  }
}
</style>
